<template>
  <div class="row">
    <div class="sending-form mr-0 col">
      <h3 v-if="selectedSuppliers.length == 0">
        {{ $t("supplier.selectSuppliers") }}
      </h3>
      <div v-else>
        <h3>
          {{
            $t("supplier.selectedSuppliers", {
              count: selectedSuppliers.length,
            })
          }}<span v-if="selectedDeliveryMethod && invalidSuppliers > 0">{{
            $t("supplier.ofWhich")
          }}</span>
        </h3>
        <p
          v-if="selectedDeliveryMethod && invalidSuppliers > 0"
          class="text-error"
        >
          <strong
            >{{ $t("supplier.inError", { count: invalidSuppliers }) }}
            <span v-if="selectedDeliveryMethod == 'print'">{{
              $t("supplier.invalidAddress")
            }}</span>
            <span v-else>{{ $t("supplier.missingEmail") }}</span></strong
          >
        </p>
        <p
          class="text-success"
          v-if="selectedDeliveryMethod && invalidSuppliers > 0"
        >
          <strong>{{
            $t("supplier.validSuppliers", { count: validSuppliers.length })
          }}</strong>
        </p>
      </div>
      <div class="form">
        <div class="form-group">
          <select
            v-model="selectedDeliveryMethod"
            class="col ml-2 mr-2 form-control form-control-sm"
          >
            <option :value="null">
              {{ $t("supplier.selectDeliveryMethod") }}
            </option>
            <option v-for="(d, key) in deliveryMethods" :value="d" :key="key">
              {{ $t("supplier." + d) }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <select
            v-model="selectedLetter"
            class="col ml-2 mr-2 form-control form-control-sm"
          >
            <option :value="null">{{ $t("supplier.selectLetter") }}</option>
            <option v-for="(l, key) in letters" :value="l" :key="key">
              {{ l | availableAsEmail(selectedDeliveryMethod, $t) }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <button
            :disabled="
              selectedSuppliers.length == 0 ||
              !selectedLetter ||
              !selectedDeliveryMethod ||
              selectedSuppliers.length == invalidSuppliers
            "
            @click="openModal"
            class="col ml-2 mr-2 btn btn-success"
          >
            {{ $t("supplier.sendLetter") }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-5">
      <embed
        v-if="
          (selectedLetter && selectedLetter.blobFI) ||
          selectedDeliveryMethod === 'print'
        "
        class="letter-preview float-left"
        :src="letterPreviewUrl"
        :key="previewKey"
      />
    </div>
    <suppliers-sender-modal
      :lettersSent="lettersSent"
      :lettersCount="lettersCount"
      :isOpen="modalOpen"
      :status="modalStatus"
      :text="modalText"
      :title="modalTitle"
      v-on:confirm="send"
      v-on:close="closeModal"
      v-on:stop="modalStatus = 'feedback'"
    ></suppliers-sender-modal>
  </div>
</template>

<script>
import SuppliersSenderModal from "./SuppliersSenderModal";
import { validateEmail } from "@/utils";

export default {
  props: ["deliveryMethods", "letters", "selectedSuppliers"],
  data() {
    return {
      selectedDeliveryMethod: null,
      selectedLetter: null,
      loading: true,
      lettersSent: 0,
      lettersCount: 0,
      text: "",
      modalStatus: "confirm",
      modalOpen: false,
      modalText: "",
      modalTitle: "",
      letterPreviewUrl: "",
      previewKey: 101,
    };
  },
  filters: {
    availableAsEmail: function (val, deliveryMethod, t) {
      if (val.blobFI && deliveryMethod == "email") {
        return t("supplier.containsAttachment", { name: val.name });
      } else {
        return val.name;
      }
    },
  },
  computed: {
    validSuppliers: function () {
      if (this.selectedDeliveryMethod == "email") {
        return this.selectedSuppliers.filter(
          (s) => s.email && s.language && validateEmail(s.email)
        );
      } else if (this.selectedDeliveryMethod == "print") {
        return this.selectedSuppliers.filter(
          (s) => this.validateAddress(s) && s.language
        );
      } else {
        return [];
      }
    },
    invalidSuppliers: function () {
      return this.selectedSuppliers.length - this.validSuppliers.length;
    },
    userData: function () {
      return this.$store.getters.userData;
    },
    userAddresses: function () {
      return this.$store.getters.userAddresses;
    },
  },
  methods: {
    closeModal: function () {
      this.modalOpen = false;
      this.modalStatus = "confirm";
    },
    validateAddress: function (supplier) {
      return (
        supplier.name &&
        supplier.street1 &&
        supplier.postOffice &&
        supplier.postalCode &&
        supplier.countryCode
      );
    },
    openModal: function () {
      this.modalStatus = "confirm";
      this.modalOpen = true;
      this.modalText = this.$t("modal.confirmSendLetter", {
        count: this.validSuppliers.length,
      });
      this.modalTitle = this.$t("modal.confirmSending");
    },

    send: async function () {
      let selectedSuppliers = this.validSuppliers;
      let selectedDeliveryMethod = this.selectedDeliveryMethod;
      let selectedLetter = this.selectedLetter;
      this.modalStatus = "loading";
      this.lettersSent = 0;
      this.lettersCount = this.validSuppliers.length;
      try {
        if (selectedDeliveryMethod == "email") {
          console.log("selected", selectedLetter);
          let request = {
            suppliers: selectedSuppliers.map((s) => s.supplierId),
            letterId: selectedLetter.letterId,
          };

          let res = await this.$store.dispatch("sendEmail", request);
          this.modalStatus = "feedback";
          this.lettersSent = res.sent.length;
          res.sent.forEach((s) => {
            this.$emit("updateSupplier", s);
          });
        } else {
          let senderAddress = this.userAddresses.find(
            (a) => a.AddressType == "Official"
          );
          if (!senderAddress) {
            this.$notify({
              type: "error",
              text: this.$t("letters.userAddressMissing"),
              duration: 5000,
            });
            return;
          } else if (
            senderAddress.Street1 === "" ||
            senderAddress.PostalCode === "" ||
            senderAddress.Country === "" ||
            senderAddress.PostalOffice === ""
          ) {
            this.$notify({
              type: "error",
              text: this.$t("letters.userAddressMissing"),
              duration: 5000,
            });
            return;
          }
          let senderData = {
            senderName: this.userData.Name,
            senderStreet1: senderAddress.Street1,
            senderStreet2: senderAddress.Street2,
            senderPostalCode: senderAddress.PostalCode,
            senderPostOffice: senderAddress.PostalOffice,
            senderCountryCode: senderAddress.Country,
            senderEmail: this.userData.Email,
            TransferID: this.userData.TransferID,
            TransferKey: this.userData.TransferKey,
            senderBusinessID: this.userData.Ytunnus,
          };
          let suppliers = selectedSuppliers.map((s) => {
            return s.supplierId;
          });
          let request = {
            senderData,
            letterId: selectedLetter.letterId,
            suppliers,
          };

          let res = await this.sendLetter(request);

          this.lettersSent = res.sent.length;
          res.sent.forEach((s) => {
            this.$emit("updateSupplier", s);
          });

          this.modalStatus = "feedback";
        }
      } catch (error) {
        console.log(error);
        this.modalStatus = "feedback";
        this.lettersSent = "?";
      } finally {
        this.$emit("updateList");
      }
    },
    sendLetter: function (req) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("sendLetter", req)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  watch: {
    selectedLetter: function (val) {
      if (val == null) {
        this.letterPreviewUrl = "";
        return;
      }
      console.log(val);
      if (val.blobFI) {
        this.$store
          .dispatch("getLetterAttachment", val.letterId)
          .then((res) => {
            this.letterPreviewUrl = res.attachment;
            this.previewKey++;
          });
      } else {
        let request = {
          letterid: val.letterId,
          lang: "FI",
        };
        this.$store.dispatch("downloadLetterPDF", request).then((res) => {
          let blob = new Blob([res.data], {
            type: res.headers.get("content-type"),
          });
          this.letterPreviewUrl = window.URL.createObjectURL(blob);
          this.previewKey++;
        });
      }
    },
    letters: function () {
      this.selectedLetter = null;
    },
    selectedDeliveryMethod: function (val) {
      if (
        this.selectedLetter &&
        this.selectedLetter.blobFI &&
        val === "email"
      ) {
        this.selectedLetter = null;
      }
    },
  },
  components: {
    SuppliersSenderModal,
  },
};
</script>

<style scoped>
.letter-preview {
  object-fit: scale-down;
  height: 100%;
}
.sending-form {
  min-height: 280px;
  max-width: 500px;
  margin: auto;
}
.sending-form p {
  font-size: 20px;
}
.sending {
  animation: fly 1300ms ease;
  animation-iteration-count: infinite;
}
.fa {
  position: absolute;
  top: 10px;
  left: 70px;
  font-size: 30px;
  color: #296c7e;
}
.sending-loader {
  position: relative;
  height: 100px;
  margin: auto;
  background: #fff;
  width: 200px;
}
@keyframes fly {
  0% {
    opacity: 0;
    transform: translate(0px, 0px);
  }

  40% {
    transform: translate(0px, 0px);
    opacity: 1;
  }
  100% {
    transform: translate(40px, -40px);
    opacity: 0;
  }
}
.loading:after {
  content: ".";
  animation: dots 2s steps(5, end) infinite;
}
.loading {
  color: hsla(191, 44%, 38%, 0.8);
  position: absolute;
  bottom: 0px;
  left: 50px;
}

@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: hsla(191, 44%, 38%, 0.8);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 hsla(191, 44%, 38%, 0.8), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 hsla(191, 44%, 38%, 0.8),
      0.5em 0 0 hsla(191, 44%, 38%, 0.8);
  }
}
</style>
